module.exports = __webpack_public_path__ + "static/media/state-machine.5736e033.svg";